<template>
  <div v-if="visible">
    <div class="dim">
      <div class="modal" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="myModalLabel">Vocabulary</h4>

              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close()">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              - 등록하시려는 단어의 뜻을 선택하신 후 [등록]버튼을 눌러주세요.<br>
              - 아래 내용 중 해당하는 뜻이 없다면 신규등록해 주시기 바랍니다.
            </div>
            <div class="modal-body" style="max-height: 400px; overflow-y: auto;">
              <h2>{{ word }}</h2>
              <div class="mt-10" v-if="vocabularies.length > 0" v-for="(vocarbulrary, index) in vocabularies" :key="index">
                <div>
                      <input @click="pickTutor(vocarbulrary)" type="radio" name="radio" id="radio" value="radio">
                      {{index + 1}}. ({{vocarbulrary.wordClass}}){{ vocarbulrary.title }}
                </div>
                <div v-html="vocarbulrary.contentHtml">
                </div>
              </div>
              <div v-if="vocabularies.length <= 0">
                해당 단어가 등록되지 않았습니다.
              </div>
            </div>
            <div class="modal-body text-center">
              <button v-if="vocabularies.length > 0" @click="selectTutors" class="btn btn-primary">등록</button>
              <button @click="close()" class="btn btn-primary">신규등록</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'tutorModal',
  props: {
    visible: {
      type: Boolean,
      require: true,
      default: false
    },
    pickSeries: {},
    word: {
      type: String,
      require: true,
      default: ''
    }
  },

  data: () => ({
    tutors: [],
    seriesInput: {},
    pop: {
      type: 'I',
      name: '',
      value: '',
    },
    tutor: {},
    vocabularies: [],
    vocabulary: {},
  }),

  watch: {
    visible: function (newVal) {
      if (newVal === true) {
        this.visible = true;
        this.getWordInfo()
      } else {
        this.visible = false;
      }
    }
  },

  mounted() {

  },

  methods: {
    close() {
      this.$emit("close", false);
    },

    getWordInfo: function () {
        const params = {
          word: this.word,
        }
        this.axios.get("/v1/api/admin/vocabularies", {
          params: this.getParams(params)
        })
        .then((res) => {
          console.log(res)
          this.vocabularies = res.data.vocabularies;
          this.vocabularies = this.vocabularies.map(value => {
            if(value.content !== null){
              value.contentHtml = value.content.replace('\n', '<br>')
            }
            return value
          })
        })
        .catch((err) => {
          this.vocabularies = []
          console.log(err)
        });
    },

    pickTutor: function (vocabulary) {
      this.vocabulary = vocabulary
    },

    selectTutors: function () {
      if(this.vocabulary !== undefined && this.vocabulary !== null && this.vocabulary !== {}){
        this.$emit("pick", this.vocabulary);
        this.$emit("close", false);
        this.vocabulary = {}
      } else {
        alert('단어를 선택해주세요.')
      }
    },
  }
}
</script>

<style scoped>
.dim {
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  box-sizing: border-box;
  z-index: 1000;
}

.modal {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/popDulicatedSerach.vue